import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum.ts';
import { numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import PropTypes from 'prop-types';

const GeoMapModal = ({ show, modalCoordinates, selectedZone, impressionsOnly = false }) => {
  if (!show || !modalCoordinates || !selectedZone) {
    return null;
  }

  const fieldStyle = {
    color: '#FFFFFF',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 500,
    fontSize: 12,
  };
  const valueStyle = {
    color: '#84818A',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 500,
    fontSize: 12,
  };

  const impressions = selectedZone.properties['Impressions'];
  const reach = selectedZone.properties['Reach'];
  const frequency = selectedZone.properties['Frequency'];

  return (
    <div className='absolute'>
      <div
        style={{
          position: 'relative',
          bottom: 50,
          top: modalCoordinates.y,
          left: modalCoordinates.x,
          flex: 1,
          width: '180px',
          height: impressionsOnly ? '55px' : '95px',
          borderRadius: 8,
          backgroundColor: 'black',
          justifyContent: 'center',
          color: 'white',
          flexDirection: 'column',
          zIndex: 10,
        }}
      >
        <div className='text-[#B6B4BA] text-xs pl-3 pt-1 w-40 text-ellipsis whitespace-nowrap overflow-hidden'>
          {selectedZone.properties[BeeswaxReportProperties.GEO_STATE] ||
            selectedZone.properties[BeeswaxReportProperties.DMA_NAME] ||
            selectedZone.properties[BeeswaxReportProperties.GEO_ZIP] ||
            selectedZone.properties[BeeswaxReportProperties.GEO_COUNTY] ||
            selectedZone.properties[BeeswaxReportProperties.GEO_CONGRESSIONAL_DISTRICTS] ||
            selectedZone.properties[BeeswaxReportProperties.CITY]}
        </div>
        <div className='flex justify-between px-3 pt-1'>
          <div style={fieldStyle}>Impressions</div>
          <div style={valueStyle}>{impressions ? numberToUsFormat(impressions) : 'N/A'}</div>
        </div>
        {!impressionsOnly && (
          <>
            <div className='flex justify-between px-3 pt-1'>
              <div style={fieldStyle}>Reach</div>
              <div style={valueStyle}>{reach ? numberToUsFormat(reach) : 'N/A'}</div>
            </div>
            <div className='flex justify-between px-3 pt-1'>
              <div style={fieldStyle}>Frequency</div>
              <div style={valueStyle}>{frequency ? numberToUsFormat(frequency) : 'N/A'}</div>
            </div>
          </>
        )}
        <div
          className='w-0 ml-[67px] h-0 
            border-l-[17px] border-l-transparent
            border-t-[17px] border-t-[#131316]
            border-r-[17px] border-r-transparent'
        ></div>
      </div>
    </div>
  );
};

GeoMapModal.propTypes = {
  show: PropTypes.bool,
  modalCoordinates: PropTypes.object,
  selectedZone: PropTypes.object,
  impressionsOnly: PropTypes.bool,
};

export default GeoMapModal;
